<div
  class="view-description"
  [ngClass]="{
    'view-description--layout-column': layout === 'column',
    'view-description--layout-drawer': layout === 'drawer'
  }">
  <div class="view-description__inner">
    <div class="view-description__header">

      <div
        class="view-description__story-title"
        [ngClass]="{'view-description__story-title--large': !chapterTitle}"
        *ngIf="storyTitle && (storyTitle != chapterTitle)">
        {{ storyTitle }}
      </div>

      <div class="view-description__chapter-title" *ngIf="chapterTitle || (chapterAudio && isEnabled(viewLayout.Audio))">
        <!-- chapter title -->
        {{ chapterTitle | textNormalize }}

        <!-- chapter audio -->
        <ng-container *ngIf="chapterAudio && isEnabled(viewLayout.Audio)">
          <app-view-audio [media]="chapterAudio" #audio></app-view-audio>

          <app-pin-button
            [icon]="audio.playing ? 'volume-mute' : 'volume'"
            [label]="audio.playing ? 'Pause Audio' : 'Play Audio'"
            [selected]="audio.playing"
            size="small"
            direction="row"
            type="ghost"
            class="ml-2"
            (click)="handleAudioPlayClick()"
          ></app-pin-button>
          </ng-container>
      </div>
    </div>
  
    <div
      *ngIf="chapterDescription"
      class="view-description__body">
      <app-view-html [html]="chapterDescription">
      </app-view-html>
    </div>

  </div>
</div>